// extracted by mini-css-extract-plugin
export default {"container":"xG-z","modal":"yG-z","dimensions":"zG-z","brandName":"AG-z","productName":"BG-z","labelValue":"CG-z","recipientEmail":"DG-z","recommendedFit":"EG-z","hiddenField":"FG-z"};